import styled from "styled-components";
import { MEDIA_QUERY } from "../../../entities/Common";

export const MixtureListItemStyled = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 20px;
  border-bottom: 1px solid #bfbfbf;
  &:last-child {
    border-bottom: none;
  }
  .mixture-item {
    &__left {
      width: calc(100% - 170px);
      padding-right: 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
    }
    &__info {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
    }
    &__name {
      font: normal normal normal 16px/18px Arial;
    }
    &__right {
      width: 170px;
    }

    &__image {
      width: 85px;
      height: 60px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &__info {
      width: calc(100% - 95px);
    }
    &__control {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &__decrement,
    &__increment {
      width: 35px;
      height: 35px;
      img {
        cursor: pointer;
      }
    }
    &__count {
      width: 100px;
      position: relative;
      text-align: center;
      span {
        display: block;
        position: absolute;
        left: 50%;
        top: 100%;
        bottom: auto;
        transform: translateX(-50%);
      }
      input {
        width: 60px;
        height: 40px;
        text-align: center;
        margin-bottom: 5px;
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
          -moz-appearance: textfield;
        }
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    .mixture-item {
      &__left {
        width: calc(100% - 100px);
        padding-right: 10px;
      }
      &__right {
        width: 100px;
      }
      &__name {
        font: 14px / 16px Arial;
      }
      &__count {
        width: 70px;
      }
      &__decrement,
      &__increment {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
`;
